import CouponRegisterContainer from './CouponRegisterContainer';
export default CouponRegisterContainer;
